import { RequirementDefinitionProfessionalLiabilityFormValues } from "../../../../types";
import { formatLimit } from "./formatLimit";

export const getProfessionalLiabilitySettings = (
  settings: Partial<RequirementDefinitionProfessionalLiabilityFormValues>
): string[] => {
  const items: string[] = [];

  items.push(`Per-claim limit: ${formatLimit(settings.perClaimLimitMinimum)}`);
  items.push(
    `Total coverage limit: ${formatLimit(settings.totalCoverageLimitMinimum)}`
  );

  if (settings.contractorDeductibleMaximum) {
    const deductible =
      settings.contractorDeductibleMaximum === "NoLimit"
        ? "No limit"
        : formatLimit(settings.contractorDeductibleMaximum);
    items.push(`Deductible maximum: ${deductible}`);
  }

  if (settings.acceptWingspanMasterPolicy !== undefined) {
    items.push(
      `Wingspan Master Policy: ${settings.acceptWingspanMasterPolicy ? "Accepted" : "Not accepted"}`
    );
  }

  return items;
};
